import React from "react";

import { Amounts, Bet, Speedometer, Step, Version } from "src/components/common";
import { Controls, Light, TutorialButton } from "./components";
import { useV3 } from "./hooks";

export const V3 = React.memo(() => {
  const { getAmountsProps, getPanelProps, getStepProps } = useV3();
  return (
    <div {...getPanelProps()}>
      <Light />
      <Speedometer />
      <TutorialButton />
      <Controls />
      <Bet />
      <Step {...getStepProps()} />
      <Amounts {...getAmountsProps()} />
      <Version />
    </div>
  );
});

V3.displayName = "V3";
